import { Flex, Text } from "@chakra-ui/core";
import React from "react";

function About() {
  return (
    <Flex
      id="about%20us"
      p={{ lg: 20, md: 10, sm: 5, xs: 5 }}
      direction="column"
      align="center"
      justify="center"
    >
      <Text fontSize="3xl" color="#3cb878">
        About Us
      </Text>
      <Text maxWidth="750px" marginY="1em" textAlign="justify" fontSize="md">
        Lorem ipsum dolor sit amet, consectetur adipisicing elit. Natus nam
        dolor repellat saepe dolores obcaecati, ea excepturi voluptatem
        voluptatum perferendis similique veniam quod laboriosam dolorum debitis
        vero maxime omnis officia cum eveniet magnam eos? Maxime numquam ratione
        nostrum molestiae maiores labore illum non! Vero obcaecati voluptatum,
        numquam voluptas dolorem dolor! Lorem, ipsum dolor sit amet consectetur
        adipisicing elit. Nobis possimus est nostrum voluptatem consequuntur
        quae suscipit deserunt eaque eius mollitia! Lorem ipsum dolor sit amet
        consectetur adipisicing elit. Sed eaque quod repellendus odio ex,
        accusantium sapiente doloribus eum illo aliquam ipsa incidunt mollitia
        ad modi? Expedita voluptatibus numquam quia earum?
      </Text>
    </Flex>
  );
}

export default About;
